<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1000px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:100px; padding-left:10px;">
            <el-button type="text">
              卷烟商品名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.name"
              placeholder="请输入卷烟商品名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
            <el-button
              type="primary"
              @click="selectMaterialFun()"
            >
              选择
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @selectTobacco="selectMaterialFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// API
import { loadTobaccoInfoListDataApi } from '@/api/v2/tobaccoInfo'

export default {
  name: 'TobaccoList',
  components: { CustomTable2 },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'tobacco_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择',
            method: 'selectTobacco'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
          industry: '云南中烟',
          status: 1
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.multipleSelection = []
        _this.tableList.initTableColumn = [
          { prop: 'name', label: '名称' },
          { prop: 'unit', label: '单位' }
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.sortOrder = ''
        _this.requestData()
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadTobaccoInfoListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0;
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false)
    },
    // 选择物料
    selectMaterialFun () {
      let _this = this;
      if (_this.multipleSelection.length < 1) {
        _this.$message({ message: '请选择卷烟商品信息', type: 'warning' })
        return
      } else {
        _this.$emit('selectedTobaccoFun', _this.multipleSelection)
        _this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
